export default "__VITE_ASSET__CzccbOA7__"